export class TxtAttach {
    public TxtAttachID?: string;
    public JurisID: number;
    public RefID?: string;
    public SeqNo?: number;
    public FileName: string;
    public Category: string;
    public Description: string;
    public BaseAttachFile: string;
    public FileSize?: number;
    public Custom1: string;
    public CreatedPFID?: string;
    public CreatedDttmUTC: Date;
    public ModifiedPFID?: string;
    public ModifiedDttmUTC?: Date;

    public SourceType: string;
    public SourceID?: number;
    public AttachedFile?: any;
    public RMSRefID?: number;
    public RecType?: number;
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/txtattach.model.ts